/* Product Card Color Swatch */

function swatchOnClick() {
  const colorSwatchesContainers = document.querySelectorAll('.ambi-swatch-container');

  colorSwatchesContainers.forEach((container) => {
    const colorSwatches = container.querySelectorAll('.ambi-color-swatch');

    colorSwatches.forEach((swatch) => {
      swatch.addEventListener('click', function () {
        console.log('onClick: Product Card Swatch');
        const variantImageUrl = this.getAttribute('data-variant-image');
        const productId = this.getAttribute('data-product-id');
        if (variantImageUrl) {
          const productImgId = 'product-image-' + productId;

          const productImage = document.getElementById(productImgId);
          console.log(`Product ID: ${productId}, productImage: `, productImage); // Debugging information
          productImage.src = variantImageUrl;
          productImage.srcset = `${variantImageUrl} 1x`; // Adjust this line according to your srcset requirements
        }
      });
    });
  });
}
document.addEventListener('DOMContentLoaded', swatchOnClick);
